import React from 'react';
import { useTranslation } from 'react-i18next';

import {
  EMPTY_ILLUSTRATIONS,
  EmptyContainer,
  Loader,
  PageLayout,
} from '@thinknet-gmbh/platform-common-ui';

import { PayrollAccountingTypeEnum, PLATFORM_PERMISSIONS, PLATFORM_RULES } from '@thinknet-gmbh/platform-common';

import { useGetCurrentCompanyId } from 'src/hooks/companies/get-current-company-id.hook';
import { useGetPayrollAccountingActiveSetting } from 'src/hooks/payroll-accounting/get-payroll-accounting-active-settings.hook';

import PermissionRouteGuard from '../../components/permission-route-guard';
import { PayrollAccountingDatev } from './components';

const PayrollAccounting: React.FC = () => {
  const { t } = useTranslation(['common', 'payrollAccounting']);

  const currentCompanyId = useGetCurrentCompanyId();

  const { setting, loading } = useGetPayrollAccountingActiveSetting(currentCompanyId);

  if (loading) {
    return <Loader />;
  }

  return (
    <PermissionRouteGuard permission={PLATFORM_PERMISSIONS.payrollAccounting} rule={PLATFORM_RULES.manageAll}>
      <PageLayout pageTitle={t('payrollAccounting:labels.pageTitle')}>
        {setting?.active && setting?.type === PayrollAccountingTypeEnum.DATEV ? (
          <PayrollAccountingDatev currentCompanyId={currentCompanyId} settingId={setting?._id} />
        ) : (
          <EmptyContainer
            illustration={EMPTY_ILLUSTRATIONS.dataAnalysis}
            emptyTitle={t('payrollAccounting:emptyContainer.noServiceSelected')}
            contentText={t('payrollAccounting:emptyContainer.noServiceSelectedSubtitle')}
          />
        )}
      </PageLayout>
    </PermissionRouteGuard>
  );
};

export default PayrollAccounting;
